import useSearchParty from 'hooks/useSearchParty';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import useContactsVariant, {
  ContactsDisplayMode,
  resolveDialogFullScreen,
  resolveDisplayMode,
} from '../hooks/use-contacts-variant';
import { generateColumns } from './services';
import { resolveSearchState } from './services/search-state';
import { ContactKind } from './types';

const useContacts = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const variant = useContactsVariant();

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [contactKind, setContactKind] = useState<ContactKind>('Person');
  const [searchText, setSearchText] = useState<string>('');
  const [preferredDisplayMode, setDisplayMode] = useState<ContactsDisplayMode>('grid');

  const {
    parties,
    isDebouncing,
    isFetching,
    isError,
  } = useSearchParty(searchText);

  const searchState = resolveSearchState({
    searchText,
    resultsCount: parties.length,
    isDebouncing,
    isFetching,
    isError,
  });

  return {
    t,
    history,
    parties,
    searchText,
    setSearchText,
    searchState,
    isFetching,
    variant,
    displayMode: resolveDisplayMode(variant, preferredDisplayMode),
    canToggleDisplayMode: variant !== 'card',
    dialogFullScreen: resolveDialogFullScreen(variant),
    setDisplayMode,
    columns: generateColumns(t),
    createModalOpen,
    setCreateModalOpen,
    contactKind,
    setContactKind,
  };
};

export default useContacts;
